import { COLORS } from "components/consts";
import { SIDEBAR_DIMENSIONS } from "./consts";

export const listItemStyles = (isOpen: boolean) => ({
    display: 'grid',
    justifyContent: !isOpen ? 'center' : 'flex-start',
    py: 0,
    my: "8px",
    ...(isOpen && { pl: 0 })
});

export const listItemButtonStyles = (isOpen: boolean, isSelected?: boolean) => ({
    display: 'block',
    justifyContent: 'center',
    borderRadius: 2,
    marginLeft: isOpen ? SIDEBAR_DIMENSIONS.MARGIN_LEFT : '',
    alignItems: 'center',
    "&.Mui-selected": {
        width: isOpen ? SIDEBAR_DIMENSIONS.OPEN_WIDTH : SIDEBAR_DIMENSIONS.CLOSED_WIDTH,
        backgroundColor: "background.default",
        "& svg": {
            color: "primary.main",
        },
        ":hover": {
            backgroundColor: "background.default",
        },
    },
    "&.Mui-focusVisible": {
        backgroundColor: "background.default",
    },
    ":hover": {
        backgroundColor: "transparent",
        color: isSelected ? null : "primary.main",
        "& svg": {
            color: "primary.main",
        },
    },
});

export const iconContainerStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

export const listItemIconStyles = (isOpen: boolean) => ({
    justifyContent: "center",
    minWidth: isOpen ? SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_OPEN : SIDEBAR_DIMENSIONS.ICON_MIN_WIDTH_CLOSED
});

export const listItemTextStyles = (isOpen: boolean) => ({
    opacity: isOpen ? 1 : 0,
    fontSize: '16px',
    color: COLORS.Romance,
    marginLeft: isOpen ? SIDEBAR_DIMENSIONS.TEXT_MARGIN_LEFT : '',
    "& .MuiListItemText-primary": {
        fontWeight: 400,
        color: COLORS.Romance,
        fontFamily: 'Inter',
        fontStyle: 'normal',
        lineHeight: '24px'
    },
});

export const sidebarTitleStyles = {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '11px',
    mt: '-5px'
};

export const sidebarTitleTextStyles = {
    fontSize: '12px',
    color: COLORS.Romance,
    fontWeight: 400,
    fontFamily: 'Inter',
    fontStyle: 'normal',
    lineHeight: '16px',
};